module.exports = __webpack_public_path__ + "img/6.3bd26d86.jpg";